<template>
    <div
        v-show="modal.activeModal"
        class="modal-overlay"
        @mousedown.self="closeModal"
    >
        <component
            :is="modal.activeModal"
            v-if="modal.activeModal"
            ref="modalRef"
            v-bind="modal.modalData"
            class="inner-modal"
            @close="hideModalInternally"
        />
    </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useModal } from './useModal';

const modal = useModal();

const modalRef = ref();

function closeModal() {
    if (modalRef.value?.$el?.dataset?.dismissable === 'false') {
        return;
    }

    modalRef.value?.onClose?.();
}

function hideModalInternally(success?: boolean) {
    if (success) {
        modal.afterSubmitRef?.();
    }
    modal.hideModal();
}
</script>

<style lang="scss" scoped>
.modal-overlay {
    position: fixed;
    z-index: 2000;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6);
    overflow: hidden;
    overscroll-behavior-y: contain;
}

.inner-modal {
    z-index: 1;
}
</style>